import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f13b0e7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2f13b0e7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13b0e7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Hero: require('/var/www/app/components/Hero.vue').default,HomeCategories: require('/var/www/app/components/HomeCategories.vue').default,HomeDiscounts: require('/var/www/app/components/HomeDiscounts.vue').default,HomeSlogan: require('/var/www/app/components/HomeSlogan.vue').default,HomeCollections: require('/var/www/app/components/HomeCollections.vue').default,HomeBestsellers: require('/var/www/app/components/HomeBestsellers.vue').default,HomeAthleteReviews: require('/var/www/app/components/HomeAthleteReviews.vue').default})
